













































import Vue from 'vue';
import Component from 'vue-class-component';
import { Watch } from 'vue-property-decorator';
import c3 from 'c3';
import d3 from 'd3';
import {ChartConfig} from '../core/interface';
import radiobox from './radiobox.vue';
import { ChartData, FormatNameValues } from '../core/chart-models';
import { c3LongRound, c3DataMaxValue, c3MinMax, getY2 } from '../core/c3-extensions';

@Component({
    props: [
        'description',
        'config',
        'showType',
        'type',
        'showGender',
        'gender',
        'slotAsLast',
        'wrapSettings'
    ],
    components: {
        radiobox
    }
})
export default class Chart extends Vue {
    private slotValue: any = null;
    private legends: any = [];
    private limitLegend: number = 3;
    chart: c3.ChartAPI;
    ET = d3.locale ({
        "decimal": ".",
        "thousands": " ",
        "grouping": [3],
        "currency": ["", "€"],
        "dateTime": "%a %b %e %X %Y",
        "date": "%m/%d/%Y",
        "time": "%H:%M:%S",
        "periods": ["AM", "PM"],
        "days": ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
        "shortDays": ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
        "months": ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
        "shortMonths": ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
    })

    get getGraphNameFromUrl(): string { return (this.$route.params as any).graphName as string }

    @Watch('config', { immediate: true, deep: true }) onPersonChanged(val: any, oldVal: any) {
        if(val) {
            let self = this;
            this.chart = this.generateChart(val);
            val.y2.data = val.y2.data || []
            let loadedData = [...val.y.data, ...val.y2.data]
            this.chart.load({
                columns: loadedData
            });
            let legendsBar = val.y.data
                .map((item: any) => item[0])
                .map((item: any) => {
                    return {
                        label: item,
                        color: self.chart.color(item),
                        type: 'bar'
                    }
                })
            let legendsLine = val.y2.data
                .map((item: any) => item[0])
                .map((item: any) => {
                    return {
                        label: item,
                        color: self.chart.color(item),
                        type: 'line'
                    }
                })
            this.legends = [...legendsBar, ...legendsLine]
        }
    }
    mounted() {
        this.slotValue = this.$slots.default;
    }

    /*
        Generate chart with default settings and return an instance of it
        in order to show and hide datasets on demand
    */

    private generateChart(config: ChartData) {

        let altConfig = {
                years: config.x.map((item: any) => item.label),
                dataY: config.y.data,
                dataYFormat: config.y.format,
                dataY2: config.y2.data || [],
                dataY2Format: config.y2.format,
                dataY2Options: config.y2.options,
                stacked: config.y.stacked,
                type: config.y.type || 'bar'
            }
        const chartConfig = this.getGeneralSumConfig(altConfig, config);
        chartConfig.bindto = '.chart__content';
        return c3.generate(chartConfig);
    }
    private getGeneralSumConfig(config: any, fullConfig: ChartData): c3.ChartConfiguration {
        // NEW
        const dataY: (string | number)[][] = fullConfig.y.data;
        const dataY2: (string | number)[][] = fullConfig.y2.data || [];
        //END NEW


        // let format2 = this.getTickFormat(config.dataY2Format);
        // let group;
        // let dataColors: any = {};
        // const colorPalette = ['#357DBA', '#A5C866', '#DF673D', '#67C4EF', '#FCBA41', '#73A580', '#97D2FB', '#DD7676', '#A4B0F5', '#ECCBD9', '#B8529E', '#16DB93'];

        // if(config.stacked) {
        //     group = [ config.dataY.map((item: any) => item[0]) ];
        // }

        // config.dataY.map((item: any) => item[0]).forEach((item: any, index: number) => {
        //     if(colorPalette[index]) {
        //         dataColors[item] = colorPalette[index];
        //     }
        // });

        // const {axes: newAxes, types: newTypes, y2: newY2} = getY2(config.dataY2, format2, config.dataY2Options);

        /**
         * Chartconfig DATA
         */

        // Custom Styles
        const general = {
            legend: { show: false},
            transition: { duration: 300},
            grid: { y: {show: true} },
            padding: { top: 10, right: 140, left: 140 }, // add padding for container so x/y labels will not get cut off
            color: { pattern: ['#357DBA', '#A5C866', '#DF673D', '#67C4EF', '#FCBA41', '#73A580', '#97D2FB', '#DD7676', '#A4B0F5', '#ECCBD9', '#B8529E', '#16DB93'] }
        }

        // Set values to zero for route change animation. Correct values will be added via @Watch('config', (... look above)
        const initialData = [...dataY, ...dataY2]
            .map((child:any[]) => {
                return child.map((grandchild: string | number) => {
                    return typeof grandchild === 'number' ? 0 : grandchild
                })
            })

        // Multidimensional array, with each element containing an array consisting of a datum name and associated data values.
        // ex: [ ['label', 0, 0], ['label', 0, 0] ]
        const columns: c3.PrimitiveArray[] = initialData;

        // Set y axis the data related to. y and y2 can be used.
        // ex: {Tulubaasi kasv: "y2"}
        const axes: { [key: string]: string } = dataY2
            .reduce((acc: {[key: string]: 'y2'}, curr: any) => {
                acc[curr[0]] = 'y2';
                return acc;
            }, {});

        //Set chart type at once: line, bar, pie, spline, step, area, area-spline, area-step, scatter, donut, gauge
        const type: string = config.type || 'bar';

        // Set chart type for each data. (overwrites type)
        // ex: { Saadavad toetused tegevuskuludeks: "bar", Tulubaasi kasv:"line" }
        const types: { [key: string]: string } = dataY2
            .reduce((acc: {[key: string]: 'line'}, curr: any) => {
                acc[curr[0]] = 'line';
                return acc;
            }, {});

        // Set groups for the data for stacking.
        // [['Maamaks', 'Reklaamimaks']]
        const groups: string[][] = (config.stacked) ? [ dataY.map((item: Array<string | number>): string => item[0].toString()) ] : [];

        // Combine data
        const data: c3.Data = {
            columns,
            axes,
            type,
            types,
            groups,
            order: null // order based on incomed data
        }

        /**
         * Chartconfig AXIS
         */

        // Chartconfig AXIS: X

        // Array that includes category names in string displayed on X axis
        // ex: [2013, 2014, ...]
        const categories: string[] = config.years;

        const x: c3.XAxisConfiguration = {
            type: 'category', // show categories instead of numbers
            categories
        };

        // Set formatter for y axis tick text.
        // ex: (val) => val €
        const yFormat: (format: string) => (value: number) => string = this.getTickFormat;

        // Chartconfig AXIS: Y
        const y: c3.YAxisConfiguration = {
            min: 0,
            max: this.getMaxValue(config.dataYFormat, config.dataY),
            tick: {
                format: yFormat(config.dataYFormat),
                count: 5
            },
            padding: { top: 0, bottom: 0}
        };

        // Chartconfig AXIS: Y2
        const y2: c3.YAxisConfiguration = {
            show: config.dataYFormat !== 'percentage' && config.dataY2.length,
            min: 0,
            max: this.getMaxValue(config.dataY2Format, config.dataY2, true),
            tick: {
                format: yFormat(config.dataY2Format),
                count: 5
            },
            padding: { top: 0, bottom: 0}
        };

        const axis: any = {
            x,
            y,
            y2
        }

        // ChartConfig Tooltip
        const tooltip: any = {
            grouped: false,
            format: {
                title: (index: any) => {
                    if(config.dataYFormat === 'percentage') { return ''; }
                    if(fullConfig && fullConfig.x[index] && fullConfig.x[index].total) {
                        return 'Kokku: ' + yFormat(config.dataYFormat)(+fullConfig.x[index].total.toFixed())
                    }
                    return '';
                }
            }
        }

        const chartConfigNew: c3.ChartConfiguration = {
            ...general,
            data,
            axis,
            tooltip
        }

        return chartConfigNew;

        // const chartConfig: c3.ChartConfiguration = {
        //     data: {
        //         columns: initialColumns,
        //         axes,
        //         type: type,
        //         types,
        //         groups: group,
        //         order: null
        //     },
        //     legend: {
        //         show: false
        //     },
        //     tooltip: {
        //         grouped: false,
        //         format: {
        //             title: (index: any) => {
        //                 if(config.dataYFormat === 'percentage') { return ''; }
        //                 if(fullConfig && fullConfig.x[index] && fullConfig.x[index].total) {
        //                     return 'Kokku: ' + format(fullConfig.x[index].total.toFixed())
        //                 }
        //                 return '';
        //             }
        //         }
        //     },
        //     axis: {
        //         x: {
        //             type: 'category',
        //             categories: config.years,
        //         },
        //         y: {
        //             padding: { top: 0, bottom: 0},
        //             min: 0,
        //             max: config.dataYFormat === 'percentage' ?
        //                     this.getDataMaxValue(config, 'percentage') :
        //                 (config.type === 'bar' && !config.stacked) ?
        //                     this.getDataMaxValue(config, 'bar') :
        //                     this.getDataMaxValue(config), // we cant use the head value only for bar chart that is not stacked,
        //                                                   // since it's max value is dependant on each individual bar
        //             tick: {
        //                 format: format,
        //                 count: 5
        //             }
        //         },
        //         y2
        //     },
        //     padding: {
        //         top: 10,
        //         right: 140,
        //         left: 140
        //     },
        //     grid: {
        //         y: {
        //             show: true
        //         }
        //     },
        //     color: {
        //         pattern: colorPalette
        //     },
        //     transition: {
        //         duration: 300
        //     }
        // };
        // return chartConfig;
    }

    private getMaxValue(format: string, data: (number | string)[][], y2: boolean = false) {
        if(!format) return 0;

        switch(format) {
            case 'percentage':
                if(!y2) return 1; // 1 === 100%
            default:
                // 1) remove labels
                // 2) SUM matrix array to single dimensional array
                const numberArray: number[] = data
                    .map((children: (string | number)[]): number[] => {
                        return children.reduce((acc: number[], curr: (number | string)) => {
                            return (typeof curr !== 'string') ? [...acc, curr] : acc;
                        }, []);
                    })
                    .reduce((a: any, b: any) => a.map((x: any, i: any) => x + b[i]));
                return c3LongRound(Math.max(...numberArray));

        }
    }

    // private getDataMaxValue(config: any, type?: string): number {
    //     let maxValue = 0;

    //     switch(type) {
    //         case 'percentage':
    //             maxValue = 1;
    //             break;
    //         case 'bar':
    //             let numberData = config.dataY.map((row: any) => {
    //                 return row.filter((item: any) => typeof item !== 'string');
    //             });
    //             maxValue = Math.max(...numberData.map((item: any) => Math.max(...item)));
    //             maxValue = c3LongRound(maxValue)
    //             break;
    //         default:
    //             let filteredArray = config.dataY.map((item: any) => item.filter((childItem: any) => typeof childItem !== 'string'));
    //             maxValue = Math.max(...filteredArray.reduce((a: any, b: any) => a.map((x: any, i: any) => x + b[i])));
    //             maxValue = c3LongRound(maxValue)
    //     }
    //     return maxValue;
    // }

    private getTickFormat(key: string): any {
        switch (key) {
            case 'currency':
                return (d: number) => {
                    return d >= 1000000 ? `${Math.round((d / 1000000) * 100) / 100} mln €` : `${this.ET.numberFormat(',')(Math.round(d))} €`;
                };
            case 'percentage':
                return d3.format("%");
            case 'people':
                return (d: any) => {
                    return `${this.ET.numberFormat(',')(Math.round(d))} inimest`;
                };
            default:
                return null;
        }
    }
    public onTypeChanged(type: any): void {
        Vue.gtm.trackEvent({category: 'Graph', action: 'change', label: 'Type', value: type});
        this.$emit('onTypeChanged', type);
    }
    public onGenderChanged(gender: any): void {
        Vue.gtm.trackEvent({category: 'Graph', action: 'change', label: 'Gender', value: gender});
        this.$emit('onGenderChanged', gender);
    }
    private toggleLegendLimit() {
        Vue.gtm.trackEvent({category: 'Graph', action: 'click', label: 'Legend toggle'});
        this.limitLegend =  (this.limitLegend === 3) ? this.limitLegend = 10000 : 3;
    }
    private legendMouseOver(label: any) {
        this.chart.focus(label);
    }
    private legendMouseOut(label: any) {
        this.chart.revert();
    }
};



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/chart.vue